<div class="div-color">
    <div class=" d-flex justify-content-center align-items-center " style="font-size: 30pt; text-align: center; color: red;">
        <i class="fa fa-times-circle fa-3x"></i>             
    </div>
    <p style="text-align: center;font-size: 30pt;  color: red;">{{"Payment Failed" }}</p>
    <p style="font-size: 18pt; text-align: center;">please try again.</p>
</div>